import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './controller_edit.routes';

import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';
import ReadonlyIf from '../../../components/directive/readonly_if/readonly_if.directive';

export class ControllerConfigEditController {
  /*@ngInject*/
  constructor($state, $stateParams, $mdDialog, SaConfigService, ControllerConfigService) {
    this.ControllerConfigService = ControllerConfigService;
    this.SaConfigService         = SaConfigService;
    this.id        = $stateParams.id;
    this.$state    = $state;
    this.$mdDialog = $mdDialog;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  $onInit() {
    this.ControllerConfigService.api.show({ id: this.id },
      response => {
        this.deviceConfig     = response;
        this.currentReadingId = this.deviceConfig.reading_device_id = this.deviceConfig.reading_device_id + '';

        this.SaConfigService.api.index(response => {
          this.readingDevices = response;
        });
      },
      err => {
        if(err.status === 404 || err.status === 403) { this.$state.go('main.home'); }
      }
    );
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        this.ControllerConfigService.api.update(
          deviceConfig,
          okResponse  => { this.$mdDialog.show(this.dialog.success); },
          errResponse => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.controllerDeviceEdit', [uiRouter, SaConfigService, ControllerConfigService, ReadonlyIf])
  .config(routing)
  .component('controllerDeviceEdit', {
      template: require('./controller_edit.html'),
      controller: ControllerConfigEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/device_config/controller_edit/controller_edit.component.js